import { Title } from '@solidjs/meta'
import { type Component, createEffect, onCleanup } from 'solid-js'
import PaymentAccountForm from '~/layers/ui/admin/cuentas-cobro/PaymentAccountForm'
import { setTrailOverride } from '~/stores/breadcrumb'

/**
 * Alta de una cuenta de cobro. La edición vive en [id].tsx: el formulario es
 * el mismo, compartido en la capa.
 */
const NuevaCuentaCobroPage: Component = () => {
  // Miga de pan propia. Se limpia al salir de la página.
  createEffect(() => {
    setTrailOverride(['Cuentas de Cobro', 'Nueva Cuenta de Cobro'])
  })
  onCleanup(() => setTrailOverride(null))

  return (
    <>
      <Title>Nueva Cuenta de Cobro | Florez Jaramillo</Title>

      <PaymentAccountForm account={() => null} />
    </>
  )
}

export default NuevaCuentaCobroPage
